import { render } from "./AssetPdfViewDetail.vue?vue&type=template&id=24575ea6"
import script from "./AssetPdfViewDetail.vue?vue&type=script&lang=js"
export * from "./AssetPdfViewDetail.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\yves-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__